/**
 * Metric categorization and grouping logic
 */

import { DetailItem, ActivityType } from './types';

/**
 * Categorizes a detail item into a logical group based on its key
 */
export const getDetailGroup = (key: string): string => {
    const normalized = key.toLowerCase();
    const includesAny = (tokens: string[]) =>
        tokens.some((token) => normalized.includes(token));

    if (normalized.startsWith('calculatedmetric.')) {
        return 'Calculated Metrics';
    }

    if (
        includesAny([
            'workout',
            'activity',
            'category',
            'type',
            'visit',
            'facility',
            'raw'
        ])
    ) {
        return 'Activity Profile';
    }

    if (
        includesAny([
            'distance',
            'speed',
            'pace',
            'calorie',
            'burned',
            'time',
            'duration',
            'steps',
            'step',
            'elevation'
        ])
    ) {
        return 'Performance';
    }

    if (includesAny(['source', 'app', 'device', 'vendor', 'platform'])) {
        return 'Source & Device';
    }

    if (
        includesAny([
            'location',
            'latitude',
            'longitude',
            'altitude',
            'accuracy',
            'geo'
        ])
    ) {
        return 'Location';
    }

    return 'Other';
};

/**
 * Infers the activity type from detail items
 */
export const getActivityTypeFromDetails = (
    items: DetailItem[]
): ActivityType => {
    const keys = items.map((item) => item.key.toLowerCase());
    if (keys.some((key) => key.includes('step'))) return 'steps';
    if (keys.some((key) => key.includes('facility') || key.includes('visit')))
        return 'facility';
    return 'workout';
};
